import { Typography } from 'antd'
import * as React from 'react'
import { FC } from 'react'
import { DataSourceItem } from '../../../shipments-page'
import { MaterialRequirementsConfiguration } from '../../../../../types/api/components/material/material-requirements-configuration'
import Order from './material-info/order/order'
import Reserve from './material-info/reserve'
import Cut from './material-info/cut'
import MaterialType from '../../../../../types/api/material-type'
const { Text } = Typography

interface MaterialInfoProps {
    data: DataSourceItem
}

const MaterialInfo: FC<MaterialInfoProps> = ({ data }) => {
    // Необходимо идти по списку требуемых материалов
    // и выводить для
    // Зарезервировать - искать сток по материалу и смотреть там наличиее резервации для данной отгрузки
    // TODO: немного не удобно вытаскивать данные, получается мы весь сток тащим и все материалы

    // Заказать - статус заявки по заказу, если она Обработана, то смотреть связанный Receipt, для вывода даты

    // Разрезать - искать сток и смотреть резервацию

    const map: {
        [key in MaterialRequirementsConfiguration['action']]: (
            config: MaterialRequirementsConfiguration,
            materialType: MaterialType,
            shipmentDocId: string
        ) => React.ReactNode
    } = {
        Заказать: (config, materialType, shipmentDocId) => (
            <Order config={config} shipmentDocId={shipmentDocId} materialType={materialType} />
        ),
        Зарезервировать: (config, materialType, shipmentDocId) => (
            <Reserve config={config} shipmentDocId={shipmentDocId} materialType={materialType} />
        ),
        Разрезать: (config, materialType, shipmentDocId) => (
            <Cut config={config} shipmentDocId={shipmentDocId} materialType={materialType} />
        ),
    }

    return (
        <>
            <Typography.Text strong>Материалы</Typography.Text>
            {data.materialRequirements?.map(req => {
                return (
                    <div key={req.id}>
                        <Text strong>{req.material_type?.name}</Text>

                        {req.configurations
                            ?.filter(conf => conf.action && conf.amount)
                            .map(config => {
                                if (!req.material_type) return null

                                const render = map[config.action]

                                return (
                                    <div key={config.id}>
                                        {render(config, req.material_type, data.documentId!)}
                                    </div>
                                )
                            })}
                    </div>
                )
            })}
        </>
    )
}

export default MaterialInfo
